import { render, staticRenderFns } from "./amenities.vue?vue&type=template&id=b93813b8&scoped=true&"
import script from "./amenities.vue?vue&type=script&lang=js&"
export * from "./amenities.vue?vue&type=script&lang=js&"
import style0 from "./amenities.vue?vue&type=style&index=0&id=b93813b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b93813b8",
  null
  
)

export default component.exports